import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { StatistiquesFiltresResponse, StatistiquesProjetResponse } from './dto/statistiques-projet-response'

export interface StatistiquesProjetFilters {
  userId?: number | null
  dateDebut?: string | null
  dateFin?: string | null
  tranchePuissance?: string | null
  region?: string | null
  typologie?: string | null
  modeValorisation?: string | null
  livrable?: string | null
}

@Injectable({
  providedIn: 'root',
})
export class StatistiqueService {
  constructor(private http: HttpClient) {}

  getStatistiquesProjets(filters: StatistiquesProjetFilters = {}): Observable<StatistiquesProjetResponse> {
    let params = new HttpParams()

    Object.entries(filters).forEach(([cle, valeur]) => {
      if (valeur !== null && valeur !== undefined && valeur !== '') {
        params = params.set(cle, valeur)
      }
    })

    return this.http.get<StatistiquesProjetResponse>(`${environment.baseUrl}/statistiques/projets`, { params })
  }

  getFiltresDisponibles(): Observable<StatistiquesFiltresResponse> {
    return this.http.get<StatistiquesFiltresResponse>(`${environment.baseUrl}/statistiques/filtres`)
  }
}
